import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class PopoverService {
  data$: Subject<any> = new Subject<any>();
}
